import React from 'react'
import check from "../../../assets/img/icons/Star 1.svg"
import profile from "../../../assets/img/temp/profile.png"
const ProfileDetail = ({inforesidencedetail}) => {
  
  return (
    <div className='ProfileDetail'>
        <div className='ProfileDetail-img'>
            <img src={inforesidencedetail.user.avatar} />

        </div>
        <div className='flex justify-center items-center mt-[10px] mb-[4px]'>
            <p className='text-[#292D32]  font-[700] text-[32px] ml-[6px]'>{inforesidencedetail.user.full_name}</p>
            <img src={check} />

        </div>
        <p className='ProfileDetail-role'> {inforesidencedetail.user.role}</p>
    </div>
  )
}

export default ProfileDetail